import { useEffect } from 'react'
import { useGetUserCurrentAnonymous } from '@dhl/receiver-user-service-api'
import { redirectUser } from './redirectUser'

export const useAuthRedirect = () => {
  const { data: userData } = useGetUserCurrentAnonymous()

  return useEffect(() => {
    if (!userData) {
      return
    }

    const { user } = userData

    if (
      !window.location.href.endsWith('/account/logout') &&
      !window.location.href.endsWith('/account/welcome') &&
      !window.location.href.includes('/account/recovery') &&
      !window.location.href.includes('/account/password-reset') &&
      !window.location.href.includes('/account/delete/error') &&
      !window.location.href.includes('/account/delete/success') &&
      !window.location.href.includes('/account/delete/expired') &&
      !window.location.href.includes('/account/verify') &&
      !window.location.href.includes('/account/sign-up/expired') &&
      !window.location.href.includes('referrer=ssa')
    ) {
      redirectUser(user)
    }
  }, [userData])
}
